import { twMerge } from "tailwind-merge";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export interface SelectItem {
    value: string;
    label: string;
}

interface SelectBoxProps {
    onChange?: (value: string) => void;
    triggerClassName?: string;
    placeholder?: string;
    contentClassName?: string;
    list: SelectItem[];
    value?: string;
    defaultValue?: string;
}

export default function SelectBox({
    onChange,
    triggerClassName,
    placeholder = "선택",
    contentClassName,
    list,
    value,
    defaultValue,
}: SelectBoxProps) {
    const boxClass = twMerge(
        "h-[34px] w-auto min-w-[160px] bg-[#fff] px-[16px] text-[14px] border-none ring-[#ddd] rounded-[5px] leading-1 ring-inset ring-1 focus:ring-1 focus:ring-console focus:ring-offset-0 [&>svg]:hidden relative after:absolute after:content-[''] after:w-[10px] after:h-[6px] after:bg-arrowSelect after:top-1/2 after:right-[16px] after:-translate-y-1/2 data-[state=open]:ring-console data-[placeholder]:text-[#999]",
        triggerClassName,
    );
    const selectClass = twMerge("bg-[#fff] text-[15px] border-[#ddd]", contentClassName);

    return (
        <Select onValueChange={onChange} value={value} defaultValue={defaultValue}>
            <SelectTrigger className={boxClass}>
                <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent className={selectClass}>
                {list.map((cont, i) => {
                    return (
                        <SelectItem key={i} value={cont.value} className="pl-[12px]">
                            {cont.label}
                        </SelectItem>
                    );
                })}
            </SelectContent>
        </Select>
    );
}
